import React, { useState, useEffect } from 'react';
import HamburgerMenu from './HamburgerMenu';
import NotificationBell from '../../common/NotificationBell';

function MobileNavigation({
  activeSection,
  onSectionChange,
  onLogout,
  user,
  isAdmin,
  isTeamlead,
  isOrgLeader,
  isAgenturLeader,
  isCallcenterLeader,
  isCallcenterMitarbeiter,
  isFachberater,
  leadCounts,
  openSettingsPanel,
  handleCustomerFilter,
  handleTeamDashboard,
  handleViewOrganizationLeads,
  onOpenOrganizationManagement,
  onOpenMembersManagement,
  onViewTeamLeads,
  navigate
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Style-Objekte für Menü-Buttons
  const menuItemStyles = {
    display: 'block',
    width: '100%',
    padding: '16px 20px',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    color: '#4a5568',
    transition: 'background-color 0.2s',
    borderBottom: '1px solid #f7fafc'
  };
  const activeMenuItemStyles = {
    ...menuItemStyles,
    backgroundColor: '#ebf4ff',
    color: '#4a6de5',
    fontWeight: '600'
  };

  // Schließe Mobile Menu wenn außerhalb geklickt wird
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen &&
        !event.target.closest('.hamburger-menu-panel') &&
        !event.target.closest('.mobile-menu-container')) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Hamburger Icon
  const hamburgerStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '24px',
    height: '18px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    zIndex: 1001
  };

  const lineStyles = {
    width: '24px',
    height: '2px',
    background: '#4a5568',
    borderRadius: '2px',
    transition: 'all 0.3s linear',
    position: 'relative',
    transformOrigin: '1px'
  };

  const line1Style = {
    ...lineStyles,
    transform: mobileMenuOpen ? 'rotate(45deg)' : 'rotate(0)',
  };

  const line2Style = {
    ...lineStyles,
    opacity: mobileMenuOpen ? '0' : '1',
    transform: mobileMenuOpen ? 'translateX(20px)' : 'translateX(0)',
  };

  const line3Style = {
    ...lineStyles,
    transform: mobileMenuOpen ? 'rotate(-45deg)' : 'rotate(0)',
  };

  // Logo Styles
  const logoStyles = {
    fontSize: '20px',
    fontWeight: '700',
    color: '#4a6de5',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  };

  // User Avatar Styles
  const userAvatarStyles = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4a6de5, #667eea)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer'
  };

  const getUserInitials = () => {
    const name = user?.full_name || user?.email || 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  };

  return (
    <>
      {/* Mobile Navigation Bar */}
      <div className="mobile-menu-container" style={{ position: 'relative' }}>
        {/* Hamburger Menu Button */}
        <button 
          style={hamburgerStyles}
          onClick={toggleMobileMenu}
          aria-label="Navigation Menu"
        >
          <div style={line1Style}></div>
          <div style={line2Style}></div>
          <div style={line3Style}></div>
        </button>
      </div>

      {/* Logo - Zentriert */}
      <div style={logoStyles}>BEN OS</div>

      {/* Notification Bell und User Avatar Container */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {(isOrgLeader || isAgenturLeader) && (
          <NotificationBell userId={user?.id} />
        )}
      {/* User Avatar */}
      <div 
        style={userAvatarStyles}
        onClick={() => {
          // Optional: User Menu öffnen oder Settings
          openSettingsPanel();
        }}
      >
        {getUserInitials()}
        </div>
      </div>

      {/* Hamburger Menu Component */}
      {mobileMenuOpen && (
        <div className="hamburger-menu-panel" style={{ position: 'fixed', top: 0, left: 0, zIndex: 1000, height: '100vh', width: 280 }}>
          <HamburgerMenu
            isOpen={mobileMenuOpen}
            onClose={closeMobileMenu}
            activeSection={activeSection}
            onSectionChange={onSectionChange}
            onLogout={onLogout}
            user={user}
            isAdmin={isAdmin}
            isTeamlead={isTeamlead}
            isOrgLeader={isOrgLeader}
            isAgenturLeader={isAgenturLeader}
            isCallcenterLeader={isCallcenterLeader}
            isCallcenterMitarbeiter={isCallcenterMitarbeiter}
            isFachberater={isFachberater}
            leadCounts={leadCounts}
            openSettingsPanel={openSettingsPanel}
            handleCustomerFilter={handleCustomerFilter}
            handleTeamDashboard={handleTeamDashboard}
            handleViewOrganizationLeads={handleViewOrganizationLeads}
            onOpenOrganizationManagement={onOpenOrganizationManagement}
            onOpenMembersManagement={onOpenMembersManagement}
            onViewTeamLeads={onViewTeamLeads}
            navigate={navigate}
          />
        </div>
      )}

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
            transition: 'opacity 0.3s ease-in-out'
          }}
          onClick={closeMobileMenu}
        />
      )}

      {/* Dashboard */}
      <button
        style={activeSection === 'dashboard' ? activeMenuItemStyles : menuItemStyles}
        onClick={() => onSectionChange('dashboard')}
      >
        🏠 Dashboard
      </button>
      {/* Callcenter Dashboard nur für Callcenter-Leader */}
      {isCallcenterLeader && (
        <button
          style={activeSection === 'callcenter-dashboard' ? activeMenuItemStyles : menuItemStyles}
          onClick={() => navigate('/callcenter-dashboard')}
        >
          📊 Callcenter Dashboard
        </button>
      )}

    </>
  );
}

export default MobileNavigation;